<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import type { FormField } from "@shared/types/Form";

  export let classes: string = "fizz-full-width fizz-flow-4 fizz-stack-16 fizz-inline-block";
  export let defaultText: string = "Select option";
  export let disabled: boolean = false;
  export let field: FormField;
  export let id: string;
  export let label: string;
  export let labelClasses: string = "fizz-stack-8";
  export let name: string;
  export let testid: string = id;
  export let options: {
    list: Option[];
    valueKey: string | null;
    textKey: string | null;
  };

  type Option = Record<number | string | symbol, any> | string;

  const dispatch = createEventDispatcher();

  const onChange = (e: Event & { currentTarget: EventTarget & HTMLSelectElement }): void => {
    dispatch("change", { target: e.currentTarget, field, fieldValue: $field });
  };

  const parseOption = (option: Option, key: string | null): string => {
    if (typeof option == "string") return option;
    if (key && option.hasOwnProperty(key)) return option[key];
    else {
      console.error(`'${key}' is not a property of ${option}`);
      return "";
    }
  };

  const textFn = (option: Option): string => parseOption(option, options.textKey);

  const valueFn = (option: Option): string => parseOption(option, options.valueKey);
</script>

<label class={classes} for={id}>
  <p class="fizz-label {labelClasses}"><strong>{label}</strong></p>
  <select
    {disabled}
    {id}
    {name}
    class:fizz-input-error={!$field.valid}
    class="fizz-select fizz-full-width"
    data-testid={testid}
    on:change={onChange}
  >
    <option value="">{defaultText}</option>
    {#each options.list as option}
      <option selected={$field.value === valueFn(option)} value={valueFn(option)}>
        {textFn(option)}
      </option>
    {/each}
  </select>
  <slot />
</label>
